import { useAppContext } from 'Context/AppContext';
import { InactiveStudents, StudyingStudents, ErrorImportStudents } from './Tabs';

export const StudentList = () => {
  const { tabNumber } = useAppContext();

  if (tabNumber === 0) return < StudyingStudents />;
  if (tabNumber === 1) return <InactiveStudents />;
  if (tabNumber === 2) return <ErrorImportStudents />;

  return <></>;
};
